import moment from "moment";

export const toDateString = (value: Date | null | undefined): string => {
  if (!value) return "";
  return moment(value).format("YYYY-MM-DD");
};
